import { Button } from "primereact/button";

import { Category } from "./Category";
import { TicketType } from "../ticketType/TicketType";
import { useAppSelector } from "../../common/hooks/useStore";
import { selectDepartmentById } from "../departments/departmentsSlice";
import ServiceCatalogBreadCrumb from "../serviceCatalog/ServiceCatalogBreadCrumb";

interface RecommendedCategoryProps {
  category: Category;
  allCategories: Category[];
  onCategorySelect: (category: Category) => void;
}

export default function RecommendedCategory({ category, allCategories, onCategorySelect }: RecommendedCategoryProps) {
  const department = useAppSelector((state) => selectDepartmentById(state, category.departmentId))!;

  return (
    <div className="flex border-1 border-round-lg border-gray-300 px-2">
      <div className="hidden md:flex flex-none align-items-center justify-content-start md:justify-content-center">
        {category.fileUri ? (
          <img className="w-full h-full" src={category.fileUri} alt="icon" />
        ) : (
          <i className={`pi ${category.icon} text-4xl`}></i>
        )}
      </div>
      <div className="flex flex-column md:flex-row justify-content-between md:align-items-center gap-2 flex-1">
        <ServiceCatalogBreadCrumb
          className="flex-1"
          pt={{
            root: { className: "border-0" },
          }}
          allCategories={allCategories}
          department={department}
          category={category}
          onCategoryClick={() => onCategorySelect(category)}
        />
        <Button
          className="w-7rem mb-2 md:mb-0 ml-2 md:ml-0"
          size="small"
          icon={category.ticketType === TicketType.Incident ? "pi pi-exclamation-triangle" : "pi pi-plus"}
          label={category.ticketType === TicketType.Incident ? "Incident" : "Cerere"}
          severity={category.ticketType === TicketType.Incident ? "warning" : "info"}
          onClick={() => onCategorySelect(category)}
        />
      </div>
    </div>
  );
}
